import type { ComponentType } from 'react';

type ComponentDecorator = <Props extends Record<string, any>>(
  component: ComponentType<Props>
) => ComponentType<Props>;

/**
 * Decorate a component with decorators in order of decorators array
 * Nesting order follows the order of decorators, where it goes from
 * inner to outer as you go down the decorators.
 *
 * @example
 * ```
 *  decorateComponent(MyComponent, [foo, bar, baz]) -> baz(bar(foo(MyComponent)))
 * ```
 */

const decorateComponent = <Props extends Record<string, any>>(
  component: ComponentType<Props>,
  decorators: ComponentDecorator[] = [],
) => (decorators.reduce((previousComponent, decorator) => decorator(previousComponent), component));

export default decorateComponent;
